import { useLocation } from 'react-router';

import { locatePath } from '@/shell/navigation';
import { Card, EmptyState } from '@/ui/Card';

/**
 * What a view looks like when its screen is not registered.
 *
 * It says so plainly. A route that renders a convincing-but-empty table is
 * indistinguishable from a broken one, and the person who finds it has no way
 * to tell whether their data is missing or the feature is.
 *
 * @returns the placeholder page
 */
export function ModulePlaceholderPage(): React.JSX.Element {
  const { pathname } = useLocation();
  const located = locatePath(pathname);

  if (located === undefined) {
    return (
      <Card title="Not found">
        <p>There is nothing at this address.</p>
      </Card>
    );
  }

  return (
    <div className="fo-page">
      <header className="fo-page__header">
        <p className="micro-label">Module</p>
        <h1>{located.view.label}</h1>
      </header>

      <EmptyState
        icon={located.destination.icon}
        title="Not built yet"
        description="This module has no implementation in this build. The route and the permission check are already real; only the screen is missing."
      />
    </div>
  );
}
